import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ms-htmlcommandbutton',
  template: `
    <p>
      ms-htmlcommandbutton works!
    </p>
  `,
  styles: []
})
export class MsHtmlcommandbuttonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
